import { StickyBar } from '@bob/library'
import { MAIN_CONTENT_ID } from '@websrc/App/AppProvider'
import { visuallyHidden } from 'leds'
import React, { FC, ReactNode } from 'react'

import { CoralLogo } from '../CoralLogo/CoralLogo'
import * as SC from './SimpleTopbar.style'

export interface SimpleTopbarProps {
  children?: ReactNode
  className?: string
}

export const SimpleTopbar: FC<SimpleTopbarProps> = ({ children, className }) => {
  return (
    <StickyBar bgColor={'grayWhite'} className={className}>
      <SC.Wrapper>
        <CoralLogo />
        <a className={visuallyHidden} href={`#${MAIN_CONTENT_ID}`}>
          Skip navigation
        </a>
        {children && children}
      </SC.Wrapper>
    </StickyBar>
  )
}
